export class ChatApiMessagesBuilder {
  build(chatMessages, currentUserMessage) {
    const historyMessages = Array.isArray(chatMessages) ? chatMessages : [];
    const normalized = historyMessages
      .map((item) => this._mapMessage(item))
      .filter(Boolean);

    const current =
      typeof currentUserMessage === "string" ? currentUserMessage.trim() : "";
    if (current) {
      normalized.push({
        role: "user",
        content: current,
        annotations: null,
        metadata: {},
      });
    }

    return normalized;
  }

  _mapMessage(item) {
    const sender = item?.sender;
    const text = typeof item?.text === "string" ? item.text.trim() : "";
    if (!text) return null;
    if (sender !== "user" && sender !== "bot") return null;

    return {
      role: sender === "user" ? "user" : "assistant",
      content: text,
      annotations: null,
      metadata: {},
    };
  }
}
